import { render, staticRenderFns } from "./stqyFbDetail.vue?vue&type=template&id=05ba2e46&scoped=true"
import script from "./stqyFbDetail.vue?vue&type=script&lang=js"
export * from "./stqyFbDetail.vue?vue&type=script&lang=js"
import style0 from "./stqyFbDetail.vue?vue&type=style&index=0&id=05ba2e46&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05ba2e46",
  null
  
)

export default component.exports